import React from 'react';
import { isRunningAsPwa } from '../pwa';

const DISMISS_KEY = 'anees_erp_pwa_install_dismissed_at';
const DISMISS_DAYS = 7;

function recentlyDismissed() {
  const value = localStorage.getItem(DISMISS_KEY);
  if (!value) return false;
  const dismissedAt = Number(value);
  if (!Number.isFinite(dismissedAt)) return false;
  return Date.now() - dismissedAt < DISMISS_DAYS * 24 * 60 * 60 * 1000;
}

function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent || '');
}

function isMobileDevice() {
  return /android|iphone|ipad|ipod/i.test(window.navigator.userAgent || '') || window.innerWidth <= 768;
}

export default function PwaInstallPrompt() {
  const [installEvent, setInstallEvent] = React.useState(null);
  const [visible, setVisible] = React.useState(false);
  const [iosHelp, setIosHelp] = React.useState(false);

  React.useEffect(() => {
    if (isRunningAsPwa()) return;
    if (!isMobileDevice()) return;
    if (recentlyDismissed()) return;

    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);

    const fallbackTimer = setTimeout(() => {
      if (!isRunningAsPwa() && isIOS() && !recentlyDismissed()) {
        setVisible(true);
        setIosHelp(true);
      }
    }, 1400);

    return () => {
      clearTimeout(fallbackTimer);
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    };
  }, []);

  React.useEffect(() => {
    const onInstalled = () => {
      setVisible(false);
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    };
    window.addEventListener('appinstalled', onInstalled);
    return () => window.removeEventListener('appinstalled', onInstalled);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  const install = async () => {
    if (!installEvent) {
      setIosHelp(true);
      return;
    }

    installEvent.prompt();
    try {
      await installEvent.userChoice;
    } catch (_) {}
    setInstallEvent(null);
    dismiss();
  };

  return (
    <div className="pwa-install-card" dir="rtl" role="dialog" aria-label="تثبيت التطبيق">
      <div className="pwa-install-icon">
        <img src="/system-logo.jpeg" alt="" />
      </div>
      <div className="pwa-install-content">
        <strong>ثبت نظام الإشارة كتطبيق</strong>
        <span>افتحه من شاشة الهاتف مباشرة بدون شريط المتصفح.</span>
        {iosHelp && (
          <small>
            في iPhone: اضغط زر المشاركة في Safari ثم اختر “إضافة إلى الشاشة الرئيسية”.
          </small>
        )}
      </div>
      <div className="pwa-install-actions">
        <button type="button" onClick={install}>تثبيت</button>
        <button type="button" className="pwa-install-later" onClick={dismiss}>لاحقاً</button>
      </div>
    </div>
  );
}
